/* VOKRA — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll (un único observer) ---------- */
  var revealObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('mt-visible');
        e.target.dispatchEvent(new CustomEvent('mt:visible'));
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }) : null;

  function initReveal(root) {
    root.querySelectorAll('.mt-reveal, .mt-lines, .mt-clip, [data-mt-observe]').forEach(function (el) {
      if (el.classList.contains('mt-visible')) return;
      if (!revealObs || reduce) { el.classList.add('mt-visible'); el.dispatchEvent(new CustomEvent('mt:visible')); return; }
      revealObs.observe(el);
    });
  }

  /* ---------- Cifras LED que suben (count-up) ---------- */
  function fmt(n, dec, sep) {
    var s = n.toFixed(dec);
    return sep === ',' ? s.replace('.', ',') : s;
  }
  function countUp(el) {
    if (el.dataset.mtDone) return;
    el.dataset.mtDone = '1';
    var to = parseFloat(el.dataset.to) || 0;
    var dec = parseInt(el.dataset.dec || '0', 10);
    var sep = el.dataset.sep || '.';
    var dur = parseFloat(el.dataset.dur || '1800');
    var bars = el.closest('[data-mt-readout]');
    bars = bars ? bars.querySelectorAll('.mt-bars i') : [];
    if (reduce) { el.textContent = fmt(to, dec, sep); bars.forEach(function (b) { b.classList.add('on'); }); return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 4);
      var v = to * e;
      if (p < 1 && Math.random() < 0.25) v += (Math.random() - 0.5) * (to * 0.02);
      el.textContent = fmt(Math.max(0, v), dec, sep);
      var lit = Math.round(e * bars.length);
      bars.forEach(function (b, i) { b.classList.toggle('on', i < lit); });
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(to, dec, sep);
    }
    requestAnimationFrame(step);
  }
  function initCounters(root) {
    root.querySelectorAll('[data-mt-count]').forEach(function (el) {
      var host = el.closest('.mt-reveal, [data-mt-observe]') || el;
      if (host === el) { el.setAttribute('data-mt-observe', ''); }
      if (host.classList.contains('mt-visible')) { setTimeout(function () { countUp(el); }, 300); return; }
      host.addEventListener('mt:visible', function () { setTimeout(function () { countUp(el); }, parseInt(el.dataset.delay || '250', 10)); }, { once: true });
    });
  }

  /* ---------- Parallax suave del hero ---------- */
  var parallaxEls = [];
  function initParallax(root) {
    root.querySelectorAll('[data-mt-parallax]').forEach(function (el) { if (parallaxEls.indexOf(el) < 0) parallaxEls.push(el); });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.dataset.mtParallax || '0.15');
        el.style.transform = 'translate3d(0,' + (-r.top * k).toFixed(1) + 'px,0)';
      });
      progressEls.forEach(updateProgress);
    });
  }

  /* ---------- Barras de progreso ligadas al scroll (pasos) ---------- */
  var progressEls = [];
  function initProgress(root) {
    root.querySelectorAll('[data-mt-progress]').forEach(function (el) { if (progressEls.indexOf(el) < 0) progressEls.push(el); updateProgress(el); });
  }
  function updateProgress(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    var p = (vh * 0.75 - r.top) / (r.height || 1);
    p = Math.max(0, Math.min(1, p));
    el.style.setProperty('--mt-p', p.toFixed(3));
    var steps = el.querySelectorAll('.mt-step');
    steps.forEach(function (s, i) { s.classList.toggle('is-on', p >= (i / Math.max(steps.length, 1)) + 0.02); });
  }

  /* ---------- Escena sticky ---------- */
  function initScene(root) {
    root.querySelectorAll('[data-mt-scene]').forEach(function (scene) {
      if (scene.dataset.mtInit) return;
      scene.dataset.mtInit = '1';
      var steps = scene.querySelectorAll('.mt-scene__step');
      var frames = scene.querySelectorAll('.mt-scene__frame');
      var bar = scene.querySelector('.mt-scene__progress');
      var cur = scene.querySelector('.mt-scene__count b');
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        frames.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
        if (bar) bar.style.setProperty('--mt-p', ((i + 1) / steps.length).toFixed(3));
        if (cur) cur.textContent = String(i + 1).padStart(2, '0');
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { obs.observe(s); });
    });
  }

  /* ---------- Inclinación 3D de tarjetas ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('[data-mt-tilt]').forEach(function (card) {
      if (card.dataset.mtInit) return;
      card.dataset.mtInit = '1';
      var max = parseFloat(card.dataset.mtTilt || '6');
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Acordeones animados (FAQ y producto) ---------- */
  function initAccordions(root) {
    root.querySelectorAll('details[data-mt-acc]').forEach(function (d) {
      if (d.dataset.mtInit) return;
      d.dataset.mtInit = '1';
      var sum = d.querySelector('summary');
      var body = d.querySelector('summary + *');
      if (!sum || !body || reduce) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.dataset.anim) return;
        d.dataset.anim = '1';
        if (d.open) {
          var h = body.scrollHeight;
          var a = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 420, easing: 'cubic-bezier(0.22,1,0.36,1)' });
          a.onfinish = function () { d.open = false; delete d.dataset.anim; };
        } else {
          d.open = true;
          var h2 = body.scrollHeight;
          var b = body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 520, easing: 'cubic-bezier(0.22,1,0.36,1)' });
          b.onfinish = function () { delete d.dataset.anim; };
        }
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      if (g.dataset.mtInit) return;
      g.dataset.mtInit = '1';
      var slides = g.querySelectorAll('.mt-gallery__slide');
      var thumbs = g.querySelectorAll('.mt-gallery__thumb');
      var counter = g.querySelector('.mt-gallery__counter b');
      var i = 0;
      function go(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        if (counter) counter.textContent = String(i + 1).padStart(2, '0');
        var t = thumbs[i];
        if (t && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - 20, top: t.offsetTop - 20, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      var prev = g.querySelector('[data-mt-prev]'), next = g.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      var main = g.querySelector('.mt-gallery__main'), sx = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); sx = null; });
      }
      g.goTo = go;
    });
  }

  /* ---------- Cantidad ---------- */
  function initQty(root) {
    root.querySelectorAll('[data-mt-qty]').forEach(function (q) {
      if (q.dataset.mtInit) return;
      q.dataset.mtInit = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1);
          input.value = Math.max(1, v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', function () {
        var form = document.getElementById(q.dataset.form);
        var hidden = form && form.querySelector('input[name=quantity]');
        if (hidden) hidden.value = Math.max(1, parseInt(input.value, 10) || 1);
      });
    });
  }

  /* ---------- Variantes ---------- */
  function initVariants(root) {
    root.querySelectorAll('[data-mt-variants]').forEach(function (box) {
      if (box.dataset.mtInit) return;
      box.dataset.mtInit = '1';
      var data;
      try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      var section = box.closest('[data-mt-pdp]');
      box.addEventListener('change', function () {
        var selected = Array.prototype.map.call(box.querySelectorAll('fieldset'), function (fs) {
          var c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
        var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
        if (!v || !section) return;
        section.querySelectorAll('form[data-type="add-to-cart-form"] input[name=id]').forEach(function (inp) { inp.value = v.id; });
        section.querySelectorAll('[data-mt-price]').forEach(function (p) { p.textContent = v.price_formatted; });
        section.querySelectorAll('[data-mt-compare]').forEach(function (p) { p.textContent = v.compare_formatted || ''; p.hidden = !v.compare_formatted; });
        section.querySelectorAll('[data-mt-atc]').forEach(function (b) {
          var label = b.querySelector('span');
          if (v.available) { b.removeAttribute('disabled'); if (label) label.textContent = b.dataset.addText; }
          else { b.setAttribute('disabled', 'disabled'); if (label) label.textContent = b.dataset.soldText; }
        });
        if (v.media_index !== null && v.media_index !== undefined) {
          var g = section.querySelector('[data-mt-gallery]');
          if (g && g.goTo) g.goTo(v.media_index);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initStickyAtc(root) {
    root.querySelectorAll('[data-mt-sticky-atc]').forEach(function (bar) {
      if (bar.dataset.mtInit) return;
      bar.dataset.mtInit = '1';
      var target = document.querySelector(bar.dataset.target);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
      var btn = bar.querySelector('[data-mt-sticky-btn]');
      if (btn) btn.addEventListener('click', function () {
        var b = target.querySelector('button[type=submit]');
        if (b && !b.disabled) b.click(); else target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initReveal(root); initCounters(root); initParallax(root); initProgress(root); initScene(root);
    initTilt(root); initAccordions(root); initGallery(root); initQty(root); initVariants(root); initStickyAtc(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); onScroll(); });
})();
